import { AxiosHttpClient } from "./httpClient.axios";

const httpClient = new AxiosHttpClient(process.env.REACT_APP_BASE_URL || "");

export default httpClient;
